import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@efexteam/components';
import useWhiteLabelService from '@/layout/login/hooks/useWhiteLabel.service';
import LogoController from '@/layout/login/components/LogoController/LogoController';
import { under_revision_v2 } from '../../assets';
import lang from '../../constants/leng';
import { selectSelectedLanguage } from '../store/language/selectors';

const DisableRevisionLayout = () => {
  const selectLanguage = useSelector(selectSelectedLanguage);
  const { whiteLabelState, getWhiteLabelFromLocalStorage } =
    useWhiteLabelService();

  useEffect(() => {
    getWhiteLabelFromLocalStorage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <Box>
        <LogoController
          isWhiteLabel={!!whiteLabelState?.organizationID}
          efexLogoProps={{ className: 'max-w-[150px] ml-4 mt-2' }}
          whiteLabelLogo={whiteLabelState.organizationLogoURL}
        />
      </Box>
      <Box className="flex flex-col items-center justify-center w-full max-w-6xl mx-auto h-[calc(100vh-100px)]">
        <Box>
          <img
            className="max-w-[150px] mb-20"
            src={under_revision_v2}
            width="100"
            alt="under_review"
          />
          <Typography variant="h4" className="!mb-4 text-center">
            {lang[selectLanguage.language].underRevisionTitle}
          </Typography>
          <Typography className="text-center !my-8">
            {lang[selectLanguage.language].underRevisionDesv2}{' '}
            <strong>
              {lang[selectLanguage.language].underRevisionSubDesv2}
            </strong>
          </Typography>
          <Typography className="text-center">
            {lang[selectLanguage.language].underRevisionContact}{' '}
            <a href="mailto:info@efexpay.com">info@efexpay.com</a>{' '}
          </Typography>
          <Box className="flex justify-center mt-10">
            <Button
              appearance="primary"
              variant="contained"
              onClick={() => {
                window.location.href = 'https://efexpay.com/';
              }}
            >
              {lang[selectLanguage.language].close}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DisableRevisionLayout;
